'use strict';

var React = require('react'),
    { flatten, findWhere, pick } = require('underscore'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    EditorCover = require('./EditorCover'),
    EditorGallery = require('./EditorGallery'),
    EditorPoster = require('./EditorPoster'),
    EditorText = require('./EditorText'),
    EditorMedia = require('./EditorMedia'),
    AddSectionControl = require('./AddSectionControl'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    AlertTypes = require('../constants/AlertTypes'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    Loader = require('../atoms/Loader'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    DragItemTypes = require('../constants/DragItemTypes'),
    SectionTypes = require('../constants/SectionTypes'),
    getScrollY = require('../utils/getScrollY'),
    StampDraftStore = require('../stores/StampDraftStore'),
    { DragDropMixin } = require('react-dnd'),
    { PropTypes } = React;

require('./Canvas.less');

var Canvas = React.createClass({
  mixins: [ClassNameMixin, DragDropMixin, PureRenderMixin],

  className: 'editor-Canvas',

  propTypes: {
    draft: PropTypes.object
  },

  configureDragDrop(registerType) {
    var imageThreshold = Math.max(120, window.innerHeight / 4),
        sectionThreshold = Math.max(140, window.innerHeight / 4),
        currentDY = 0,
        frame;

    function makeScrollingHandler(threshold) {
      function getScrollDY(clientY) {
        var speed;
        if (clientY < threshold) {
          // -1 to 0 as we move from 0 to threshold
          speed = -1 + clientY / threshold;
        } else if (clientY > window.innerHeight - threshold) {
          // 0 to 1 as we move from (innerHeight - threshold) to innerHeight
          speed = 1 - (window.innerHeight - clientY) / threshold;
        } else {
          speed = 0;
        }

        return Math.round(speed * 10);
      }

      function tick() {
        if (!currentDY) {
          frame = null;
          return;
        }

        window.scrollTo(0, getScrollY() + currentDY);
        frame = window.requestAnimationFrame(tick);
      }

      function queueScroll(dy) {
        currentDY = dy;

        if (!frame) {
          frame = window.requestAnimationFrame(tick);
        }
      }

      function cancelScroll() {
        window.cancelAnimationFrame(frame);
        frame = null;
        currentDY = 0;
      }

      return {
        dropTarget: {
          enter: cancelScroll,
          leave: cancelScroll,
          acceptDrop: cancelScroll,

          getDropEffect() {
            return null;
          },

          over(item, e) {
            queueScroll(getScrollDY(e.clientY));
          }
        }
      };
    }

    registerType(DragItemTypes.SECTION, makeScrollingHandler(sectionThreshold));
    registerType(DragItemTypes.IMAGE, makeScrollingHandler(imageThreshold));
  },

  getSections() {
    return this.props.draft.content.sections;
  },

  render() {
    const { draft } = this.props;

    return (
      <div className={this.getClassName()}>
        <div className='editor-Canvas-sections'
             {...this.dropTargetFor(DragItemTypes.SECTION, DragItemTypes.IMAGE)}>
          {draft ?
            flatten(this.getSections().map(this.renderSectionWithAddControl)) :
            <Loader absoluteCenter />
          }
        </div>
      </div>
    );
  },

  renderSectionWithAddControl(section, index) {
    return [
      this.renderSection(section, index),
      <AddSectionControl key={'add-' + section.uuid}
                         afterSectionId={section.uuid}
                         isLast={index === this.getSections().length - 1} />
    ];
  },

  renderSection(section, index) {
    var props = this.getSectionProps(section, index);

    switch (section.type) {
    case SectionTypes.COVER:
      return (
        <EditorCover {...pick(props, 'index', 'uuid', 'key')}
                     background={section.background}
                     title={section.title}
                     subtitle={section.subtitle} />
      );
    case SectionTypes.GALLERY:
      return (
        <EditorGallery {...props}
                       images={section.images}
                       layout={section.layout} />
      );
    case SectionTypes.POSTER:
      return (
        <EditorPoster {...props}
                      background={section.background}
                      caption={section.caption} />
      );
    case SectionTypes.TEXT:
      return (
        <EditorText {...props}
                    text={section.text} />
      );
    case SectionTypes.MEDIA:
      return (
        <EditorMedia {...props}
                     section={section} />
      );
    }
  },

  getSectionProps(section, index) {
    var uuid = section.uuid,
        isNew = StampDraftStore.isLastAddedItem();

    return {
      key: uuid,
      uuid,
      index,
      isNew,
      onDeleteClick: this.handleDeleteClick
    };
  },

  handleDeleteClick(sectionKey, needConfirm) {
    var section = findWhere(this.getSections(), { uuid: sectionKey });

    if (needConfirm) {
      AlertActionCreators.showAlert(AlertTypes.EDITOR_DELETE_SECTION, {
        sectionId: section.uuid,
        sectionType: section.type
      });
    } else {
      DraftActionCreators.deleteSection(section.uuid);
    }
  }
});

module.exports = Canvas;



/** WEBPACK FOOTER **
 ** ./editor/Canvas.jsx
 **/